import React, { Fragment } from "react";
import MetaTagComponent from "../../../common/Meta/MetaTagComponent";
import { metaAiDevelopment } from "../../../../Utilites";
import ServiceDetailSection from "../../../services/ServiceDetailSection";
import { BarChart3, Bot, Brain, ChartColumnIncreasing, Cloud, Code, Globe, Package, Shield, Target, Trophy, Zap } from "lucide-react";

const AiDevelopment = () => {
  const service = {
    slug: "ai-development",
    title: "AI Development",
    description:
      "Intelligent solutions powered by machine learning and artificial intelligence to automate and optimize business processes.",
    shortDescription:
      "Intelligent solutions powered by machine learning and AI.",
    icon: Brain,
    gradient: "from-purple-500 to-indigo-500",
    features: [
      "Machine Learning Models",
      "Natural Language Processing",
      "Computer Vision",
      "Predictive Analytics",
      "Automation Solutions",
      "AI Consulting",
    ],
    benefits: [
      "Process Automation",
      "Data-Driven Insights",
      "Improved Efficiency",
      "Competitive Advantage",
    ],
    process: [
      "Data Assessment",
      "Model Development",
      "Training & Validation",
      "Integration & Deployment",
      "Continuous Learning",
    ],
    image:
      "/assets/img/services/details/AI-development.png",
  };
  const extension = {
    keyFeatures: [
      {
        name: "Machine Learning Models",
        description: "Custom ML models for your specific needs",
        icon: Brain,
      },
      {
        name: "Natural Language Processing",
        description: "Advanced text and speech understanding",
        icon: Globe,
      },
      {
        name: "Computer Vision",
        description: "Image and video analysis capabilities",
        icon: Target,
      },
      {
        name: "Predictive Analytics",
        description: "Data-driven future predictions",
        icon: BarChart3,
      },
      {
        name: "Automation Solutions",
        description: "Intelligent process automation",
        icon: Zap,
      },
      {
        name: "AI Consulting",
        description: "Strategic AI implementation guidance",
        icon: Shield,
      },
    ],
    benefits: [
      {
        title: "Process Automation",
        description: "Reduce manual work and increase efficiency",
        icon: Bot,
      },
      {
        title: "Data-Driven Insights",
        description: "Extract valuable insights from your data",
        icon: ChartColumnIncreasing,
      },
      {
        title: "Improved Efficiency",
        description: "Optimize operations with intelligent systems",
        icon: Zap,
      },
      {
        title: "Competitive Advantage",
        description: "Stay ahead with cutting-edge AI",
        icon: Trophy,
      },
    ],
    process: [
      {
        step: "Data Assessment",
        description: "Evaluate your data quality and availability",
        duration: "1 week",
      },
      {
        step: "Model Development",
        description: "Design and build custom AI models",
        duration: "3-6 weeks",
      },
      {
        step: "Training & Validation",
        description: "Train models and validate performance",
        duration: "2-4 weeks",
      },
      {
        step: "Integration & Deployment",
        description: "Integrate AI into your systems",
        duration: "2-3 weeks",
      },
      {
        step: "Continuous Learning",
        description: "Monitor and improve model performance",
        duration: "Ongoing",
      },
    ],
    techStack: [
      { name: "Python", icon: Code, category: "Language" },
      { name: "TensorFlow", icon: Brain, category: "ML Framework" },
      { name: "PyTorch", icon: Brain, category: "ML Framework" },
      { name: "OpenAI GPT", icon: Globe, category: "LLM" },
      { name: "AWS SageMaker", icon: Cloud, category: "ML Platform" },
      { name: "Docker", icon: Package, category: "Deployment" },
    ],
  };
  return (
    <Fragment>
      <MetaTagComponent metaDetails={metaAiDevelopment} />
      <ServiceDetailSection service={service} extension={extension} />
    </Fragment>
  );
};

export default AiDevelopment;
